import { combineEpics } from 'redux-observable';
import { getNextSectionEpic, getPrevSectionEpic, goToSectionEpic } from 'app/reducers/router';

export const rootEpic = combineEpics(getNextSectionEpic, getPrevSectionEpic, goToSectionEpic);
